import * as React from "react";
import { LoadingSpinner } from "../../components/ui/loading-spinner";
const MarkdownImpl = React.lazy(() => import("./markdown-impl"));
const customComponents = {};
function getComponents(components) {
    return Object.assign(Object.assign({}, components), customComponents);
}
/**
 * Lazy loads a markdown presenter.
 *
 * @example
 *
 * ```jsx
 * import { Markdown } from "@skve/components"
 *
 * function Demo() {
 *   return <Markdown content="Hi **Mum** - wie gehts dir? ;)" />
 * }
 * ```
 */
export const Markdown = (props) => (React.createElement(React.Suspense, { fallback: React.createElement(LoadingSpinner, null) },
    React.createElement(MarkdownImpl, Object.assign({}, props, { getComponents: getComponents }))));
export function defineMarkdownComponents(components) {
    Object.assign(customComponents, components);
}
//# sourceMappingURL=markdown.js.map